<template>
  <v-expand-transition>
    <v-list>
      <v-list-item-group>
        <template v-for="(item, index) in items">
          <v-divider :key="`divider-${index}`" v-if="index"></v-divider>
          <v-list-item :key="`d-${index}`" @click="clicked(item)">
            <v-list-item-content>
              <v-list-item-title class="text-uppercase">{{ item.name }}</v-list-item-title>
              <v-list-item-subtitle v-html="item.subTitle"></v-list-item-subtitle>
            </v-list-item-content>

            <v-list-item-action v-if="isEditable">
              <v-icon class="icon-far-right">{{ nextIcon }}</v-icon>
            </v-list-item-action>
          </v-list-item>
        </template>
      </v-list-item-group>
    </v-list>
  </v-expand-transition>
</template>

<script>
import API from '@/services/api.js'
import ActionButton from '@/components/Common/ActionButton'
import WorkplacesList from '@/components/Common/Workplace/WorkplacesList'
import LinkWorkplaceModal from '@/components/Company/LinkWorkplaceModal'
import LinkInstructorModal from '@/components/Company/LinkInstructorModal'
import {RulesMixin, CompanyRoles} from '@/components/mixins'
import {mapActions, mapGetters} from 'vuex'
import findIndex from 'lodash/findIndex'
import find from 'lodash/find'
import groupBy from 'lodash/groupBy'
import filter from 'lodash/filter'

// @group common
// ListItem component
export default {
  name: 'ListItem',

  mixins: [RulesMixin, CompanyRoles],

  props: {
    // employee object
    items: {
      // `Object`
      type: Array
    },
    // Should fields be editable
    //Next icon prop
    nextIcon: {
      type: String,
      // `'String'`
      default: '$sl-arrow-right'
      // The default value is icon: `$sl-arrow-right`
    },
    isEditable: {
      // `true` / `false`
      type: Boolean,
      // The default value is: `true`
      default: true
    }
  },

  components: {},
  watch: {},
  data: () => ({}),
  methods: {
    clicked(item) {
      if (this.isEditable == true) {
        this.$emit('clickedDepartment', {id: item.id, departmentName: item.name})
      }
      return
    }
  },
  mounted() {
    this.$scrollToTop()
  },
  created() {}
}
</script>
